export const createSettingsConfig = (history,setSelectedItemId) => ({
    isEnabled: true,
    items: [
        {
            title: "settings",
            id: "1",
            clickable: {
                type: 'button',
                onClick: () => {
                    history.push('/settings');
                    setSelectedItemId('');
                    return {
                        preventOverlayClose: false
                    };
                },
            },
        },
    ]
});